export class GermplasmPairModel {
    constructor(public entryNumber?: number,
                public testGroupId?: number,
                public testGID?: number,
                public testDesignation?: string,
                public standardGroupId?: number,
                public standardGID?: number,
                public standardDesignation?: string
    ) {
    }
}